export const createFanHubEvent = (evtguid: string) => {
	try {
		const trkGuid = process.env.REACT_APP_FANHUB_TAGGING || "";
		window.FanHub?.createEvent(evtguid, trkGuid, window.location.href);
	} catch (e) {
		console.error(e);
	}
};
